import { render, staticRenderFns } from "./stockPricingMatrix.vue?vue&type=template&id=2769e840&"
import script from "./stockPricingMatrix.vue?vue&type=script&lang=js&"
export * from "./stockPricingMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports